import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { STARTER_API,donorapi } from '../../ApiNames';

export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchDataViewSuccess = (dataview: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: dataview,
});
export const fetchAddDataSuccess = (adddata: any) => ({
    type: 'FETCH_ADD_DATA_SUCCESS',
    payload: adddata,
});
export const fetchDataSuccessfile = (imgdata: any) => ({
    type: 'FETCH_ADD_DATA_SUCCESS_file',
    payload: imgdata,
});
export const fetcheditdatares = (editdat: any) => ({
    type: 'FETCH_EDIT_DATA_SUCCESS_file',
    payload: editdat,
});
export const fetchdeldatasuccess = (deletedata:any)=>({
    type : 'fetch_delete_data_success',
    payload:deletedata,
});


export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid, q :5 };
            const apiname = donorapi.document;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const viewdata = (DocId:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { did:DocId,q:4};
            const apiname = donorapi.deletedocument;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const adddata = (document:any,date:any,adddatafile:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { document:document,date1:date,filename:adddatafile,uid:uid};
            const apiname = donorapi.adddocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchAddDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


export const UploadImageData = (fileToUpload:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const apiname = donorapi.docfile;
            // Create FormData and append the file
            const formData = new FormData();
            const fileName = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload', fileToUpload, fileName);
            const response = await LoginService.uploadimage(apiname, formData);
            dispatch(fetchDataSuccessfile(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const doceditdata = (doc_name:any,expiry_date:any,adddatafile:any,id:any,UserID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { title:doc_name,edate:expiry_date,filename:adddatafile,did:id,q:1,uid:UserID};
            const apiname = donorapi.deletedocument;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetcheditdatares(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const doceditdatanoimage = (doc_name:any,expiry_date:any,id:any,UserID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { title:doc_name,edate:expiry_date,did:id,q:1,uid:UserID};
            const apiname = donorapi.deletedocument;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetcheditdatares(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const deletedocdata = (DocID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {did:DocID,q:3};
            const apiname = donorapi.deletedocument;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdeldatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};

